// Libs
import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// DLS
import "@collectivehealth/dls-icons/dist/elements/dls-icon-menu";

// Styles
import styles from "./MenuBar.css";

// Components
import RenderIf from "components/RenderIf";

// Context
import PageTitleContext from "contexts/PageTitle";
import SidebarDisplayStateContext from "contexts/sidebar/DisplayState";
import EmergencyAddContext from "contexts/emergencyAdd/EmergencyAdd";

// Constants
import DATA_HOOKS from "./MenuBar.datahooks";

export default function MenuBar({
  children,
  hiddenWhenExpanded = false,
  isTriggerLabelDisplayed = true
}) {
  const [, setIsSidebarDisplayed] = useContext(SidebarDisplayStateContext);
  const [isEmergencyAddPageDisplayed] = useContext(EmergencyAddContext);

  const [pageTitle] = useContext(PageTitleContext);

  return (
    <div
      className={classNames(styles.root, {
        [styles.hiddenWhenExpanded]: hiddenWhenExpanded || !children
      })}
      data-hook={DATA_HOOKS.ROOT}
    >
      <RenderIf test={!isEmergencyAddPageDisplayed}>
        <div className={styles.sidebarTriggerContainer}>
          <button
            className={styles.sidebarTriggerButton}
            onClick={() => {
              setIsSidebarDisplayed(true);
            }}
          >
            <dls-icon-menu slot="icon-label-glyph" />
          </button>
          <span
            className={classNames(styles.sidebarTriggerLabel, {
              [styles.hidden]: !isTriggerLabelDisplayed
            })}
            data-hook={DATA_HOOKS.SIDEBAR_TRIGGER_LABEL}
          >
            {pageTitle}
          </span>
        </div>
      </RenderIf>
      <div
        className={
          isEmergencyAddPageDisplayed
            ? styles.emergencyAddChildrenContainer
            : styles.childrenContainer
        }
      >
        {children}
      </div>
    </div>
  );
}

MenuBar.propTypes = {
  children: PropTypes.node,
  hiddenWhenExpanded: PropTypes.bool,
  isTriggerLabelDisplayed: PropTypes.bool
};

MenuBar.Divider = ({ className }) => <div className={classNames(styles.divider, className)} />;
